export default __webpack_public_path__ + "static/media/53.5129ee3e.svg";